import React from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import { ImageContainer, Image, IconButton } from "./image-cropper.styled";
import ConfirmationModal from "../ConfirmationModal";

export const ImagePreview = ({ file, onDeletePreview }: any) => {
  const [showBlockActivity, setShowBlockActivity] = React.useState(false);
  return (
    <>
      <ImageContainer>
        <IconButton
          onClick={() => setShowBlockActivity(true)}
          className="d-flex justify-content-center align-items-center"
        >
          <AiFillCloseCircle />
        </IconButton>
        <Image src={file} alt="" />
      </ImageContainer>
      <ConfirmationModal
      
        open={showBlockActivity}
        onClose={() => {
          setShowBlockActivity(false);
        }}
        onConfirm={() => onDeletePreview(file)}
        title="Are you sure?"
        description={`Deleted file can not be recovered`}
      />
    </>
  );
};
